export default __webpack_public_path__ + "static/media/2093-00.67c6f515.jpg";